export default "__VITE_ASSET__taM0w2Sh__ 640w, __VITE_ASSET__CIYDMO2E__ 1024w, __VITE_ASSET__PK0gy0sZ__ 1536w";